module.exports = __webpack_public_path__ + "static/media/current-mappin.0782936a.svg";